export default __webpack_public_path__ + "static/media/WhiteSurvey.e615bbce.svg";